import Menu from '@/global/components/MenuV2'
import Grid from '@/global/components/ui/Grid'
import { LayoutFolha } from '@acme/core'
import { Divider } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'

export default function IntegracaoFolha() {
    return (
        <section id="integracao-folha">
            <Divider sx={{ userSelect: 'none', mb: 3, mt: 4 }}>
                Integração com a folha de pagamento
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <FormField
                        name="codEmpresaFolha"
                        label="Código da empresa"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    Caso use integração com folha de pagamento,
                                    informe o código da empresa no seu sistema
                                    de folha de pagamento.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={7}>
                    <FormField
                        name="layoutFolha"
                        label="Layout de exportação"
                        select
                        InputProps={{
                            endAdornment: <AjudaLayoutFolha />,
                        }}
                    >
                        <Menu.Item value={LayoutFolha.DOMINIO}>
                            Domínio (Horas)
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.DOMINIO_DECIMAL}>
                            Domínio (Decimal)
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.FORTES_5}>
                            Fortes v5
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.FORTES_6}>
                            Fortes v6
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.QUESTOR_01}>
                            Questor 01
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.QUESTOR_02}>
                            Questor 02
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.QUESTOR_03}>
                            Questor 03
                        </Menu.Item>
                        <Menu.Item value={LayoutFolha.SYSTEM}>System</Menu.Item>
                        <Menu.Item value={LayoutFolha.DATA_CEMPRO}>
                            Data Cempro
                        </Menu.Item>
                    </FormField>
                </Grid>
                <Grid item xs={6} className="inline-flex items-center">
                    <FormFieldCheckbox
                        name="exportarHorasFaltaJustificada"
                        label="Exportar faltas justificadas em horas"
                    />
                    <IconeAjuda>
                        Caso esteja marcado, as faltas justificadas e
                        injustificadas serão exportadas em horas, caso
                        contrário, serão exportadas em dias. Quando banco de
                        horas está habilitado, apenas as faltas da competência
                        atual serão exportadas em dias.
                    </IconeAjuda>
                </Grid>
                <Grid item xs={5} className="inline-flex items-center">
                    <FormFieldCheckbox
                        name="exportarHorasFaltaIntegral"
                        label="Exportar faltas integrais em horas"
                    />
                    <IconeAjuda>
                        Caso esteja marcado, as faltas integrais serão
                        exportadas em horas, caso contrário, serão exportadas em
                        dias. Não é compatível com banco de horas.
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}

function AjudaLayoutFolha() {
    return (
        <IconeAjuda className="mr-4">
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        maxWidth: '50%',
                        overflowWrap: 'break-word',
                    }}
                >
                    Essa configuração define como os dados serão exportados para
                    a folha de pagamento.
                </div>
                <div>
                    <span>F - Funcionário</span>
                    <br />
                    <span>C - Competência</span>
                    <br />
                    <span>R - Rubrica</span>
                    <br />
                    <span>V - Valor</span>
                    <br />
                    <span>E - Empresa</span>
                    <br />
                    <span>P - Pis</span>
                </div>
            </div>
            <br />
            <br />
            <div
                style={{
                    overflowWrap: 'break-word',
                    overflowY: 'auto',
                    maxHeight: '150px',
                }}
            >
                <li>
                    <strong>Domínio</strong>:<br />
                    10FFFFFFFFFFCCCCCCRRRR11VVVVVVVVVEEEEEEEEEE
                </li>
                <li>
                    <strong>Fortes</strong>:
                    <br />
                    1FFFFFFRRRvvvvvvv.vvVVVVVVVVVVVV.VV
                </li>
                <li>
                    <strong>Questor 01</strong>:
                    <br />
                    0;EEEE;000;FFFFFFFFF;RRRR;0000;vvvvvvvvvvv;VVVVVVVVVVV;
                </li>
                <li>
                    <strong>Questor 02</strong>:
                    <br />
                    EEE;FFFFFF;RRR;VVVVV;vvvvvvvvv;
                </li>
                <li>
                    <strong>Questor 03</strong>:
                    <br />
                    EEEE;FFFFFF;RRR;VVV,VV
                </li>
                <li>
                    <strong>System</strong>:
                    <br />
                    RRRRFFFFFFvvvv.vvVVVVVVVVVVVV.VV
                </li>
                <li>
                    <strong>Data Cempro</strong>:
                    <br />
                    FFFFFFFFFFRRRRVVV:VV:VVPPPPPPPPPPP
                </li>
            </div>
        </IconeAjuda>
    )
}
